import React from 'react';
export function SectionDivider() {
  return <div className="flex items-center justify-center py-8" aria-hidden="true" data-id="element-222">
      <div className="h-px w-16 md:w-24 bg-[#B8A068] opacity-50" data-id="element-223"></div>
      <div className="mx-4 w-2 h-2 rounded-full bg-[#B8A068] opacity-70" data-id="element-224"></div>
      <div className="h-px w-16 md:w-24 bg-[#B8A068] opacity-50" data-id="element-225"></div>
    </div>;
}